import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const AboutVideo = ({ button, link, idLink }) => {
  const [isOpen, setOpen] = useState(false);
    const hasValidVideo = idLink && idLink !== "ERROR";
  return (
    <>
      {" "}
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId={idLink}
        onClose={() => setOpen(false)}
      />
      {/* End popup modal video */}
        {button ? (

                hasValidVideo? (
                    <button
                        type="button"
                        onClick={() => setOpen(true)}
                        className="theme-btn btn-style-one text-center w-100 small play-now">
                        {button}
                    </button>
                ):(
                    <span className="theme-btn btn-style-one text-center w-100 small btn-bg-gray2">
                        {button}
                    </span>
                )

            ) : (
            <div className="video-box">
                <figure className="image">
                    <div className="play-now" role="button" onClick={() => setOpen(true)}>
                        <img
                            width={815}
                            height={364}
                            src="/images/resource/video-img.jpg"
                            alt="video banner"
                        />
                        <i className="icon flaticon-play-button-3" aria-hidden="true"></i>
                    </div>
                </figure>
            </div>
            )
        }
    </>
  );
};

export default AboutVideo;
